import i18n from '../i18n';
import { peoplePlatformAPI } from '../services/api';
import { normalizeToSupportedUiLanguage } from '../constants/uiLanguages';

/**
 * Applique la langue UI (i18n) et enregistre `metadata.preferences.langue` sur la fiche People liée.
 */
export async function syncUiLanguageToMemberProfile(user, lang) {
  const code = normalizeToSupportedUiLanguage(lang);
  await i18n.changeLanguage(code);
  const pid = String(user?.member_id || user?.person_id || '').trim();
  if (!pid) return;
  try {
    const res = await peoplePlatformAPI.getById(pid);
    const existing = res?.data?.metadata?.preferences || {};
    await peoplePlatformAPI.update(pid, {
      metadata: {
        preferences: { ...existing, langue: code },
      },
    });
  } catch (e) {
    console.warn('syncUiLanguageToMemberProfile', e);
  }
}
